let inc = 0;

export function hyperLiquidWsRequestId(): number {
  inc += 1;

  return inc;
}
